/** @jsx jsx */
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import defaultsDeep from 'lodash/defaultsDeep';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { withNamespaces } from 'react-i18next';
import throttle from 'lodash/throttle';
import { Container, Row, Column } from '../../../styles/Grid';
import Spacer from '../../ui/Spacer';
import CtaLink from '../../ui/CtaLink';
import BackToTop from '../../ui/BackToTop';
import DotComponent from '../../ui/DotComponent';
import {
  types,
  sizes,
  decorations,
  arrows,
  arrowPositions,
} from '../../ui/CtaLink/types';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import SiteMapBlock from './SitemapBlock';
import get from 'lodash/get';
import * as styles from './index.styles';

const defaultData = {
  Headline: {
    value: '',
  },
  BackLink: {
    value: {
      href: null,
      text: null,
      target: null,
    },
  },
  SiteMap: {
    value: [],
  },
};

export class HtmlSitemap extends SafePureComponent {
  constructor(props) {
    super(props);
    this.state = {
      shouldRenderBackToTop: false,
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.throttledHandleScroll, true);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.throttledHandleScroll);
  }

  handleScroll = () => {
    const lastScrollY = window.scrollY;
    this.setState({ shouldRenderBackToTop: lastScrollY > 500 });
  };

  throttledHandleScroll = throttle(this.handleScroll, 50);

  safeRender() {
    const { t } = this.props;
    const fields = defaultsDeep(this.props.fields, defaultData);
    const { Headline, BackLink, SiteMap } = fields;
    const hasGeoHeadline = Boolean(Headline.value);
    const headlineDefault = { value: 'Sitemap' };
    const shouldRenderBacklink = Boolean(BackLink.value.href);
    const blocksData = SiteMap.value;
    const blockColumns = blocksData.map((block, index) => {
      const links = get(block, 'links', []);
      return (
        <Column
          cols={{ sm: 6, md: 4, lg: 4, xl: 3 }}
          css={styles.blockItem}
          key={index}
        >
          <SiteMapBlock links={links} />
        </Column>
      );
    });
    const { shouldRenderBackToTop } = this.state;

    return (
      <Spacer>
        <Container css={styles.mainContainer}>
          <Row>
            <Column>
              <h1 css={styles.headline}>
                <Text
                  field={hasGeoHeadline ? fields.Headline : headlineDefault}
                />
                <DotComponent />
              </h1>
            </Column>
          </Row>

          {shouldRenderBacklink && (
            <Row>
              <Column css={styles.backlink}>
                <CtaLink
                  type={types.tertiary}
                  size={sizes.small}
                  arrow={arrows.left}
                  arrowPosition={arrowPositions.start}
                  decoration={decorations.none}
                  href={BackLink.value.href || '#'}
                  text={t('BackButton') || ''}
                />
              </Column>
            </Row>
          )}

          <Row css={styles.blocksContainer}>{blockColumns}</Row>
          {shouldRenderBackToTop && <BackToTop css={styles.backToTop} />}
        </Container>
      </Spacer>
    );
  }
}

HtmlSitemap.propTypes = {
  fields: PropTypes.shape({
    Headline: PropTypes.shape({
      value: PropTypes.string,
    }),
    BackLink: PropTypes.shape({
      href: PropTypes.string,
      text: PropTypes.string,
      target: PropTypes.string,
    }),
    SiteMap: PropTypes.shape({
      value: PropTypes.arrayOf(PropTypes.object),
    }),
  }),
};

export default withNamespaces()(HtmlSitemap);
